import { colors } from '@insurancemenu/imenu-components-lib';
import { Reload } from '@insurancemenu/imenu-components-lib/dist/icons';
import styled from 'styled-components';

export const ModalNotesStyled = styled.p`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const ModalNoteStyled = styled.b`
  color: ${colors.neutral[900]};
`;

export const ReloadIconStyled = styled(Reload)`
  margin-bottom: 0.5rem;
`;
